import { render, staticRenderFns } from "./ConfigReservas.vue?vue&type=template&id=28676577"
import script from "./ConfigReservas.vue?vue&type=script&lang=js"
export * from "./ConfigReservas.vue?vue&type=script&lang=js"
import style0 from "./ConfigReservas.vue?vue&type=style&index=0&id=28676577&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports